"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function apex(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 15.1875L12 5.625L19.5 15.1875V18.375L12 8.8125L4.5 18.375V15.1875ZM12.375 16.125C11.8777 16.125 11.4008 15.9275 11.0492 15.5758C10.6975 15.2242 10.5 14.7473 10.5 14.25C10.5 13.7527 10.6975 13.2758 11.0492 12.9242C11.4008 12.5725 11.8777 12.375 12.375 12.375C12.8723 12.375 13.3492 12.5725 13.7008 12.9242C14.0525 13.2758 14.25 13.7527 14.25 14.25C14.25 14.7473 14.0525 15.2242 13.7008 15.5758C13.3492 15.9275 12.8723 16.125 12.375 16.125Z", fill: color }));
}
exports["default"] = apex;
//# sourceMappingURL=apex.js.map